import React, { useState, useEffect } from 'react'
import Select from 'react-select'
import { Dropdown, Col, Row } from 'react-bootstrap'
import queryString from 'query-string';
import httpStatus from 'http-status';

import {rolesService} from '../../../../../_services/roles.service'

export default function FilterDropdown({ history }) {
  const [roleId, setRoleId] = useState()
  const [status, setStatus] = useState()
  const [userType, setUserType] = useState()

  const [roleIdSelected, setRoleIdSelected] = useState()
  const [rolesOption, setRolesOption] = useState([])

  const FilterToggle = React.forwardRef(({ onClick }, ref) => (
    <div 
      ref={ref}
      onClick={(e) => { e.preventDefault(); onClick(e);}}
      className={`message__view__btn text-center mr-3 ${status || userType || roleId ? 'bg-success text-white' : ''}`}
    >
      <i className="fas fa-filter fa-xs"></i> &nbsp;Filter
    </div>
  ));

  const FilterMenu = React.forwardRef(
    ({ style, className, 'aria-labelledby': labeledBy }, ref) => {
      const statusOptions = [
        {value: 'Active', label: 'Active'},
        {value: 'Pending', label: 'Pending'},
        {value: 'Inactive', label: 'Inactive'},
      ]

      const userTypeOptions = [
        {value: 'Staff', label: 'Staff'},
        {value: 'Licensed', label: 'Licensed'},
      ]

      const statusSelected = statusOptions.find((statusOpt) => {
        return statusOpt.value === status;
      });
  
      const userTypeSelected = userTypeOptions.find((userTypeOpt) => {
        return userTypeOpt.value === userType;
      });

      const handleSelectOption = (selected, filterType) => {
        const { [filterType] : removedProperty,  ...searchParams } = queryString.parse(history.location.search)

        searchParams.page = 1;

        if (selected) {
          searchParams[filterType] = selected.value
        }

        history.replace(`/account/users?${queryString.stringify(searchParams)}`)
      }

      const reactSelectStyles = {
        placeholder: (styles) => {
          return {
            ...styles, 
            color: 'RGB(201, 201, 201)',
            fontWeight: 300,
          };
        },
        control: (styles) => {
          return {
            ...styles, 
            border: 'unset',
            background: '#F5F8FA'
          };
        },
        dropdownIndicator: (styles) => {
          return {
            ...styles, 
            color: '#373737'
          };
        },
        indicatorSeparator: (styles) => {
          return {
            ...styles, 
            display: 'none'
          };
        },
      }

      return (
        <div
          ref={ref}
          style={style}
          className={className}
          aria-labelledby={labeledBy}
        >
          
          <div className='px-3 pt-2 font-weight-light'>Filter Options</div>
          <hr />
          
          <div className='px-3 pb-2'>
            <Row className='mb-1'>
              <Col className='font-weight-light'>Role:</Col>
            </Row>
            <Row>
              <Col>
                <Select
                  value={roleIdSelected || ''}
                  options={rolesOption}
                  styles={reactSelectStyles}
                  onChange={(selected) => handleSelectOption(selected, 'roleId')}
                  isClearable={true}
                  placeholder=''
                />
              </Col>
            </Row>

            <br />

            <Row className='mb-1'>
              <Col className='font-weight-light'>Status:</Col>
            </Row>
            <Row>
              <Col>
                <Select
                  value={statusSelected || ''}
                  options={statusOptions}
                  styles={reactSelectStyles}
                  onChange={(selected) => handleSelectOption(selected, 'status')}
                  isClearable={true}
                  placeholder=''
                />
              </Col>
            </Row>
            
            <br />

            <Row className='mb-1'>
              <Col className='font-weight-light'>User Type:</Col>
            </Row>
            <Row>
              <Col>
                <Select
                  value={userTypeSelected || ''}
                  options={userTypeOptions}
                  styles={reactSelectStyles}
                  onChange={(selected) => handleSelectOption(selected, 'type')}
                  isClearable={true}
                  placeholder=''
                />
              </Col>
            </Row>
          </div>
        </div>
      );
    },
  );

  useEffect(() => {
    setRoleIdSelected(rolesOption.find(roleOpt => {
      return parseInt(roleOpt.value) === parseInt(roleId);
    }))
  }, [rolesOption, roleId])

    useEffect(() => {
      rolesService.retrieveOptionsRoles()
        .then(response => {
          if (response && response.status === httpStatus.OK) {
            setRolesOption(response.data.data.map(result => {
              return { value: result.id, label: result.name }
            }))
          }
        })
        .catch(() => {
          setRolesOption([])
        })
    }, []);

  useEffect(() => {
    const queryParams = queryString.parse(history.location.search);

    setRoleId(queryParams.roleId || '');
    setStatus(queryParams.status || '');
    setUserType(queryParams.type || '');
  }, [history.location.search]);

  return (
    <Dropdown>
      <Dropdown.Toggle as={FilterToggle} />
      <Dropdown.Menu 
        alignRight 
        as={FilterMenu} 
        style={{width: '225px'}} 
        className='border-0 axs-shadow' 
      />
    </Dropdown>
  )
}
